import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCommentsOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.25 10.5417C19.2532 11.7516 18.9705 12.9451 18.425 14.025C17.7782 15.3191 16.7839 16.4076 15.5535 17.1685C14.3231 17.9295 12.9051 18.3328 11.4583 18.3334C10.2485 18.3365 9.05494 18.0538 7.975 17.5084L2.75 19.25L4.49167 14.025C3.94619 12.9451 3.66351 11.7516 3.66667 10.5417C3.66723 9.09497 4.07056 7.67697 4.83149 6.44653C5.59242 5.21609 6.6809 4.2218 7.975 3.57503C9.05494 3.02955 10.2485 2.74687 11.4583 2.75003H11.9167C13.8273 2.85544 15.632 3.66189 16.985 5.01498C18.3381 6.36807 19.1446 8.17271 19.25 10.0834V10.5417Z",
		stroke: "#454545",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCommentsOutline;
